import { usePageContent } from '../../hooks/usePageContent';
import useMeta from '../../hooks/useMeta';
import './your-plate-your-story.css';
import useTitle from '../../hooks/useTitle';

const YourPlateYourStoryPage = () => {
  const { find, meta } = usePageContent('your-plate-your-story');
  const seo = meta?.seo;
  useTitle(seo?.title || 'Your Plate. Your Story.');
  useMeta(seo);
  const c = find('richText') || {};
  return (
    <div id="content">
      <div className="page-header">
        <div className="container">
          <h1 className="page-header__title">{c.pageTitle || 'Your Plate. Your Story.'}</h1>
        </div>
      </div>
      <div className="content-holder content-holder--indented">
        <div className="rich-text" dangerouslySetInnerHTML={{ __html: c.richTextHtml || '' }} />
      </div>
    </div>
  );
};

export default YourPlateYourStoryPage;
